import {distributionAccountContainer} from './distribution-account/distribution-account.reducer';
import {fetchingContainer} from './fetching/fetching.reducer';
import {notificationContainer} from './notification/notfication.reducer';
import {partnersContainer} from './partner/partner.reducer';
import {segmentsContainer} from './segment/segment.reducer';
import {segmentValidationsContainer} from './segment/info/validation/validation.reducer';
import {targetContainer} from './target/target.reducer';
import {userContainer} from './user/user.reducer';
import {pubmaticReducer} from './segment/info/shared-targets-list/account-pubmatic/pubmatic-state';
import {segmentsReducer} from './segment/segments.state';
import {targetsReducer} from './target/target.state';
import {globalStateReducer} from './store/global.reducer';
import {filtersConfigReducer} from './filters-config/filters-config.reducer';

export const reducers = {
  distributionAccountContainer,
  segmentsContainer,
  targetContainer,
  userContainer,
  notificationContainer,
  partnersContainer,
  fetchingContainer,
  segmentValidationsContainer,
  // TODO rename after refactor to segments
  segmentsSlice: segmentsReducer,
  targetsSlice: targetsReducer,
  pubmatic: pubmaticReducer,
  global: globalStateReducer,
  filtersConfig: filtersConfigReducer
};

